<template>
  <HomeCollaborateAndRecentViewsSkeletonLoader
    v-if="loading"
    :is-admin-on="isAdminOn"
    :is-admin-role="isAdminRole"
  />
  <div
    v-else
    class="home-collaborate-and-recent-views"
    :class="{ 'is-admin-on': isAdminOn, 'is-not-admin-role': !isAdminRole }"
  >
    <div class="collaborate-and-recent-views-header">
      <div
        class="collaborate-tab mr-2"
        :class="{ active: activeTab === 'collaborate' }"
        @click="activeTab = 'collaborate'; homeClick('Collaborate');"
      >
        <DpplSvg
          file-name="collaborate-icon"
          class="collaborate-icon"
        />
        Collaborate
      </div>
      <div
        class="recent-views-tab"
        :class="{ active: activeTab === 'recent-views' }"
        @click="activeTab = 'recent-views'; homeClick('Recently Viewed');"
      >
        <DpplSvg
          file-name="recently-viewed-icon"
          class="mr-2"
        />
        Recently Viewed
      </div>
    </div>
    <div
      v-if="activeTab === 'collaborate'"
      class="tab-content"
    >
      <HomeCollaborateTab />
    </div>
    <div
      v-else
      class="tab-content"
    >
      <HomeRecentViewsItem
        v-for="({
          timestamp, name, params, query, meta,
        }, index) in recentViewsItems"
        :key="timestamp"
        :name="name"
        :meta="meta"
        :params="params"
        :query="query"
        :timestamp="timestamp"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useHome } from '@/stores/home/home';
import { useTracking } from '@/stores/tracking/tracking';
import { useAppAuthData } from '@/stores/app/authData';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import { defineAsyncComponent } from 'vue';
import HomeCollaborateAndRecentViewsSkeletonLoader
  from './HomeCollaborateAndRecentViewsSkeletonLoader.vue';
import HomeCollaborateTab from './HomeCollaborateTab.vue';

const HomeRecentViewsItem = defineAsyncComponent(() => import('./HomeRecentViewsItem.vue'));

export default {
  name: 'HomeCollaborateAndRecentViews',
  components: {
    HomeCollaborateTab,
    HomeRecentViewsItem,
    HomeCollaborateAndRecentViewsSkeletonLoader,
    DpplSvg,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    isAdminOn: {
      type: Boolean,
      default: false,
    },
    isAdminRole: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: 'collaborate',
    };
  },
  computed: {
    ...mapState(useHome, ['recentViewsItems']),
    ...mapState(useAppAuthData, ['authData']),
  },
  methods: {
    ...mapActions(useTracking, ['homeClick']),
  },
};
</script>

<style lang="less" scoped>
.home-collaborate-and-recent-views {
  margin-top: 53px;
  width: 380px;
  height: calc(100% - 200px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  &.is-admin-on {
    margin-top: 117px;
  }

  &.is-not-admin-role {
    margin-top: 144px;
  }
}

.collaborate-and-recent-views-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.collaborate-tab {
  width: 186px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 16px;
  font-size: 16px;
  font-weight: 700;
  color: @text-lighter;
  cursor: pointer;
  z-index: 2;
  background: fade(@grey-400, 20%);

  :deep(svg) path, :deep(svg) circle {
    stroke: @stroke-dark;
  }

  &.active, &:hover {
    color: @text-darkest;

    :deep(svg) path, :deep(svg) circle {
      stroke: @grey-900;
    }
  }
}

.recent-views-tab {
  width: 186px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 16px;
  font-size: 16px;
  font-weight: 700;
  color: @text-lighter;
  cursor: pointer;
  z-index: 2;
  background: fade(@grey-400, 20%);

  :deep(svg) path, :deep(svg) circle {
    stroke: @stroke-dark;
  }

  &.active, &:hover {
    color: @text-darkest;

    :deep(svg) path, :deep(svg) circle {
      stroke: @grey-900;
    }
  }
}

.tab-content {
  width: 380px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 600px;
  max-height: 600px;
  overflow-y: auto;
}

.collaborate-icon {
  margin-right: 10px;
}
</style>
